import React from 'react';
import { CalendarClock } from 'lucide-react';
import { adminApi } from '../../../lib/adminAuth';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../../ui/sheet';
import RetainerGapPanel from './RetainerGapPanel';

// Compact chip for the Invoices tab; opens the full panel in a side sheet.
export default function RetainerGapChip({ onOpenInvoice, refreshKey }) {
  const [summary, setSummary] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    adminApi.get('/api/admin/accounting/retainer-gaps').then((r) => setSummary(r.data.summary)).catch(() => {});
  }, [refreshKey]);

  const count = (summary?.gap || 0) + (summary?.due || 0);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full border text-xs font-semibold transition-colors active:scale-95 ${count ? 'bg-red-50 border-red-200 text-red-700 hover:bg-red-100' : 'bg-white border-slate-200 text-slate-600 hover:border-fuchsia-300'}`}
        data-testid="retainer-gap-chip">
        <CalendarClock className="w-3.5 h-3.5" /> Retainer gaps
        <span className={`px-1.5 rounded-md tabular-nums ${count ? 'bg-red-600 text-white' : 'bg-slate-100'}`} data-testid="retainer-gap-chip-count">{count}</span>
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-3xl bg-white overflow-y-auto" data-testid="retainer-gap-sheet">
          <SheetHeader className="mb-4">
            <SheetTitle className="text-[#1a1a2e]">Retainer billing check</SheetTitle>
            <SheetDescription>Retainer clients that haven&apos;t been invoiced for their current billing period.</SheetDescription>
          </SheetHeader>
          <RetainerGapPanel refreshKey={refreshKey} onSummary={setSummary}
            onOpenInvoice={(inv) => { setOpen(false); onOpenInvoice?.(inv); }} />
        </SheetContent>
      </Sheet>
    </>
  );
}
